import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";

export const usePostDischargeData = (patientId: number) => {
	const queryClient = useQueryClient();
	const queryKey = ["post-discharge-data", { patientId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			return await EndpointsService.dataRetriever.getPostDischargeInfo(patientId);
		},
	});

	return {
		...query,
		retry: 0,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
